import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';
import { SqaService } from 'projects/services/src/app/API/sqa.service';
import { BootStrapDatePicker } from 'projects/shared/src/app/pmkvy-shared/date-picker-bootstrap/date-picker-bootstrap.component';
import { UserService } from 'projects/services/src/app/API/userservice/user-service.service';
import { DropdownService } from 'projects/services/src/app/API/dropdown.service';
import { UtilityServiceService } from 'projects/services/src/app/API/utility-service.service';
import { AadhaarService } from 'projects/services/src/app/API/aadharService/aadhaar.service';
import { ValidationService } from "projects/services/src/app/validation.service";
import * as moment from 'moment';
declare var swal: any;
declare var toastr: any;

@Component({
  selector: 'app-trainer-assessor-nomination',
  templateUrl: './trainer-assessor-nomination.component.html',
  styleUrls: ['./trainer-assessor-nomination.component.css']
})
export class TrainerAssessorNominationComponent implements OnInit {
  typeOfSkilling: 'basic' | 'advance' | null = null;
  formTitle = '';
  nominationOption: 'trainer' | 'assessor' | 'both' | null = null;
  previousOption: 'trainer' | 'assessor' | 'both' | null = null;

  nominationForm: FormGroup;
  stateOptions: any[] = [];
  districts: any[] = [];
  nomineeDistricts: any[] = [];
  sectors: any[] = [];
  isIntroductionExpanded: boolean = false;
  @ViewChild('introductionPanel') introductionPanel!: ElementRef;
  allowedFormats = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG', 'mp4'];
  onlyFilesAllowedFormats = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];
  localFileName = {
    photoVideo: '',
    tradeCertificateDocs: '',
    undertaking: ''
  };
  typesOfInstitutes: string[];
  typesOfuserCategories: string[];
  genderOptions: any;
  tradeNames: string[] = [];
  nosCodes: string[] = [];
  trainerCategories = [
    'New Trainer',
    'Existing Trainer',
    'Master Trainer'
  ];

  assessorCategories = [
    'New Assessor',
    'Existing Assessor',
    'Master Assessor'
  ];
  _isAadhaarValidated: boolean = false;
  d = new Date();
  curr_date = this.d.getDate();
  curr_month = this.d.getMonth() + 1;
  curr_year = this.d.getFullYear();
  assessmentLanguagesList: any;
  preferredLanguages: string[]
  dateInput: {
    startDate: BootStrapDatePicker;
  } = {
      startDate: {
        minDate: {
          day: 1,
          month: 1,
          year: 1900
        },
        maxDate: {
          day: this.curr_date,
          month: this.curr_month,
          year: this.curr_year
        },
        placeholder: "Select Date Of Birth",
        required: true,
        errorMessage: "Date is required"
      }
    };
  adhaarValue: any;
  tradeMessage: any;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private geographyService: GeographiesService,
    private sectorService: SectorsService,
    private router: Router,
    private sqaService: SqaService,
    private userService: UserService,
    private dropdownService: DropdownService,
    public utilityService: UtilityServiceService,
    public aadharService: AadhaarService,
  ) { }

  ngOnInit(): void {
    this.typeOfSkilling = this.route.snapshot.queryParamMap.get('type') as 'basic' | 'advance';
    this.formTitle = this.typeOfSkilling === 'basic'
      ? 'Basic Trainer/Assessor Nomination'
      : 'Advance Trainer/Assessor Nomination';

    this.buildForm();
    this.initNominationType();
    this.getStates();
    this.getSectors();
    this.getFormDropdownValues();
    // this.getLanguages();
    this.setupStateDistrictLogic('state', 'district', 'lgdCode', this.districts);
    this.setupStateDistrictLogic('nomineeState', 'nomineeDistrict', 'nomineeLgdCode', this.nomineeDistricts);
    this.typesOfuserCategories = [...this.trainerCategories];


  }

  getStates() {
    this.geographyService.getStates().subscribe((res) => {
      if (res) {
        this.stateOptions = res.states;
      }
    });
  }
  getFormDropdownValues() {
    this.genderOptions = ["Female", "Male", "Transgender"];
    this.typesOfInstitutes = ['AICTE Polytechnic',
      'Central Tool Room & Training Center',
      'ATDC',
      'CIPET',
      'Co-operatative Society',
      'CTTC',
      'District Agriculture Training centre',
      'Deemed State Govt Training Center',
      'Government',
      'Govt. College',
      'KVIC',
      'KVK',
      'Industrial Training Center',
      'JSS',
      'MSME Technology Centre',
      'Nirmithi Kendra Training Center',
      'Pradhan Mantri Kaushal Kendra(PMKK)',
      'RUDSETI',
      'Rural Self Employment Training Institute (RSETI)',
      'Private Partner',
      'Semi-Government',];
    // this.typesOfuserCategories = [
    //   'New Trainer',
    //   'New Assessor',
    //   'Existing Trainer',
    //   'Existing Assessor',
    //   'Master Trainer',
    //   'Master Assessor',
    // ];
    this.preferredLanguages = [
      'Hindi',
      'Telugu',
      'Malayalam',
      'Kannada',
      'Marathi',
      'Punjabi',
      'Assamese',
      'Gujarati',
      'Odia',
      'Tamil',
      'Bengali',
      'English'
    ];
  }
  toggleIntroduction(): void {
    this.isIntroductionExpanded = !this.isIntroductionExpanded;
  }
  getPanelHeight(): string {
    if (this.introductionPanel && this.isIntroductionExpanded) {
      return `${this.introductionPanel.nativeElement.scrollHeight}px`;
    }
    return '0px';
  }
  getDistrictsInTheState() {
    this.districts = [];
    this.nominationForm.get('district').setValue('');
    this.geographyService.getDistricts(this.nominationForm.get('state').value.code)
      .subscribe(districts => {
        this.districts = districts.districts;
      }, error => {
        console.log(`Error while fetching districts : ${error}`);
      });
  }
  private setupStateDistrictLogic(
    stateControlName: string,
    districtControlName: string,
    lgdCodeControlName: string,
    districtList: any[]
  ) {
    this.nominationForm.get(stateControlName)?.valueChanges.subscribe((selectedState) => {
      if (selectedState) {
        this.nominationForm.get(districtControlName)?.setValue('');
        this.nominationForm.get(lgdCodeControlName)?.setValue('');
        districtList.length = 0;
        this.geographyService.getDistricts(selectedState.code).subscribe({
          next: (res) => {
            districtList.push(...res.districts);
          },
          error: (err) => {
            console.error(`Error fetching districts for ${stateControlName}:`, err);
          }
        });

      } else {
        this.nominationForm.get(districtControlName)?.setValue('');
        this.nominationForm.get(lgdCodeControlName)?.setValue('');
        districtList.length = 0;
      }
    });
    this.nominationForm.get(districtControlName)?.valueChanges.subscribe((selectedDistrict) => {
      if (selectedDistrict) {
        this.nominationForm.get(lgdCodeControlName)?.setValue(selectedDistrict.code || '');
      } else {
        this.nominationForm.get(lgdCodeControlName)?.setValue('');
      }
    });
  }
  getSectors() {
    if (this.sectors.length) {
      return;
    }
    this.sectorService.getSectorsForPublic().subscribe((sectors) => {
      this.sectors = sectors;
    });
  }

  private initNominationType(): void {
    const type = this.route.snapshot.queryParamMap.get('type') as 'basic' | 'advance' | null;

    if (type === 'basic' || type === 'advance') {
      this.typeOfSkilling = type;
      this.nominationOption = 'trainer';
      this.previousOption = 'trainer'
      // this.onOptionChange();
    }
    else {
      this.typeOfSkilling = null;
      this.nominationOption = null;
      this.previousOption = null
    }
  }
  buildForm() {
    this.nominationForm = this.fb.group({
      //Institute & SPOC
      typeOfInstitute: ['', Validators.required],
      nameOfInstitute: ['', Validators.required],
      tpId: ['', [Validators.required, Validators.maxLength(9)]],
      tpEmail: ['', [Validators.required, Validators.email, ValidationService.emailValidator]],
      tcId: ['', [Validators.required, Validators.maxLength(9)]],
      tcSpocName: ['', Validators.required],
      tcSpocEmail: ['', [Validators.required, Validators.email, ValidationService.emailValidator]],
      contactNumber: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      designation: ['', Validators.required],
      state: ['', Validators.required],
      district: ['', Validators.required],
      lgdCode: ['', Validators.required],

      //Trainer/Assessor
      participantName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email, ValidationService.emailValidator]],
      whatsappNumber: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      gender: ['', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      aadhaarNumber: ['', [Validators.required, Validators.maxLength(12), Validators.pattern(/^[1-9][0-9]{11}$/)]],
      aadhaarVerified: [false],
      dob: ['', [Validators.required]],
      nomineeState: ['', Validators.required],
      nomineeDistrict: ['', Validators.required],
      nomineeLgdCode: ['', Validators.required],

      trIdPrefix: ['', Validators.required],
      trId: ['', [
        Validators.required,
        startsWithValidator(['TR', 'T-']),
        Validators.pattern(/^(TR|T-)[A-Za-z0-9]+$/)
      ]],
      // trId: ['', [Validators.required, startsWithValidator('TR'), Validators.pattern(/^TR[0-9]+$/)]],
      arIdPrefix: [''],
      arId: ['',],
      // arId: ['', [Validators.required, startsWithValidator('AR'), Validators.pattern(/^AR[0-9]+$/)]],

      tradeName: ['', Validators.required],
      nosCode: ['', Validators.required],
      sector: ['', Validators.required],
      userCategory: ['', Validators.required],
      preferredLanguage: ['', Validators.required],

      //Documents
      photoVideo: [null, Validators.required],
      tradeCertificateDocs: [null, Validators.required],
      undertaking: [null, Validators.required],
    });
  }
  get validForm() {
    if (this.nominationForm.valid && this._isAadhaarValidated ) {
      return true;
    } else {
      return false;
    }
  }
  onOptionChange(newOption: 'trainer' | 'assessor' | 'both') {
    swal({
      title: 'Are you sure?',
      text: "Changing option will clear all entered data",
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Continue",
    }).then((action: any) => {
      if (action.value) {
        this.nominationOption = newOption;
        this.previousOption = newOption;
        this.resetFormForOption();
        if (newOption === 'trainer') {
          this.typesOfuserCategories = [...this.trainerCategories];
        } else if (newOption === 'assessor') {
          this.typesOfuserCategories = [...this.assessorCategories];
        } else {
          this.typesOfuserCategories = [...this.trainerCategories, ...this.assessorCategories];
        }

      }
      else {
        this.nominationOption = this.previousOption;
      }

    });
  }

  private resetFormForOption(): void {
    this.nominationForm.reset();
    this.nominationForm.patchValue(this.getNominationFormDefaults());
    this.dateInput.startDate = {
      minDate: {
        day: 1,
        month: 1,
        year: 1900
      },
      maxDate: {
        day: this.curr_date,
        month: this.curr_month,
        year: this.curr_year
      },
      placeholder: "Select Date Of Birth",
      required: true,
      errorMessage: "Date is required"
    };

    if (this.nominationOption === 'trainer') {
      this.nominationForm.get('trId')?.setValidators([
        Validators.required,
        startsWithValidator(['TR', 'T-']),
        Validators.pattern(/^(TR|T-)[A-Za-z0-9]+$/)
      ]);
      this.nominationForm.get('trIdPrefix')?.setValidators([
        Validators.required
      ]);
      this.nominationForm.get('arId')?.clearValidators();
      this.nominationForm.get('arIdPrefix')?.clearValidators();
    } else if (this.nominationOption === 'assessor') {
      this.nominationForm.get('arId')?.setValidators([
        Validators.required,
        startsWithValidator(['AR', 'A-']),
        Validators.pattern(/^(AR|A-)[A-Za-z0-9]+$/)
      ]);
      this.nominationForm.get('arIdPrefix')?.setValidators([
        Validators.required
      ]);
      this.nominationForm.get('trId')?.clearValidators();
      this.nominationForm.get('trIdPrefix')?.clearValidators();
    } else if (this.nominationOption === 'both') {
      this.nominationForm.get('trId')?.setValidators([
        Validators.required,
        startsWithValidator(['TR', 'T-']),
        Validators.pattern(/^(TR|T-)[A-Za-z0-9]+$/)
      ]);
      this.nominationForm.get('trIdPrefix')?.setValidators([
        Validators.required,
      ]);
      this.nominationForm.get('arId')?.setValidators([
        Validators.required,
        startsWithValidator(['AR', 'A-']),
        Validators.pattern(/^(AR|A-)[A-Za-z0-9]+$/)
      ]);
      this.nominationForm.get('arIdPrefix')?.setValidators([
        Validators.required
      ]);
    }

    this.nominationForm.get('trId')?.updateValueAndValidity();
    this.nominationForm.get('trIdPrefix')?.updateValueAndValidity();
    this.nominationForm.get('arId')?.updateValueAndValidity();
    this.nominationForm.get('arIdPrefix')?.updateValueAndValidity();

    this._isAadhaarValidated = false;
    this.nominationForm.get('aadhaarNumber')?.setValidators([
      Validators.required,
      Validators.maxLength(12),
      Validators.pattern(/^[1-9][0-9]{11}$/)
    ]);
    this.nominationForm.get('aadhaarNumber')?.enable();
    this.nominationForm.get('aadhaarNumber')?.updateValueAndValidity();

    this.nominationForm.get('participantName')?.setValidators([Validators.required]);
    this.nominationForm.get('participantName')?.enable();
    this.nominationForm.get('participantName')?.updateValueAndValidity();

    this.nominationForm.get('gender')?.setValidators([Validators.required]);
    this.nominationForm.get('gender')?.enable();
    this.nominationForm.get('gender')?.updateValueAndValidity();

    this.nominationForm.get('dob')?.setValidators([Validators.required]);
    this.nominationForm.get('dob')?.enable();
    this.nominationForm.get('dob')?.updateValueAndValidity();
  }


  private getNominationFormDefaults() {
    return {
      nameOfInstitute: '',
      typeOfInstitute: '',
      tpId: '',
      tpEmail: '',
      tcId: '',
      tcSpocName: '',
      tcSpocEmail: '',
      contactNumber: '',
      designation: '',
      state: '',
      district: '',
      lgdCode: '',
      participantName: '',
      email: '',
      whatsappNumber: '',
      gender: '',
      mobileNumber: '',
      aadhaarNumber: '',
      aadhaarVerified: false,
      dob: null,
      nomineeState: '',
      nomineeDistrict: '',
      nomineeLgdCode: '',
      trIdPrefix: '',
      trId: '',
      arIdPrefix: '',
      arId: '',
      tradeName: '',
      nosCode: '',
      sector: '',
      userCategory: '',
      preferredLanguage: '',
      photoVideo: null,
      tradeCertificateDocs: null,
      undertaking: null,
    };
  }

  getLanguages() {
    this.dropdownService.getLanguagesForPmkvyBatch().subscribe((res) => {
      this.assessmentLanguagesList = res.languagesKnown;
      console.log(res, "languages");
    });
  }
  private buildFinalPayload(): any {
    const f = this.nominationForm.getRawValue();

    return {
      nameOfInstitute: f.nameOfInstitute,
      typeOfInstitute: f.typeOfInstitute,
      tpId: f.tpId,
      tpEmail: f.tpEmail,
      tcId: f.tcId,
      tcSpocName: f.tcSpocName,
      tcSpocEmail: f.tcSpocEmail,
      contactNumber: f.contactNumber,
      designation: f.designation,
      state: f.state.name,
      district: f.district.name,
      lgdCode: f.lgdCode,
      participantName: f.participantName,
      email: f.email,
      whatsappNumber: f.whatsappNumber,
      gender: f.gender,
      mobileNumber: f.mobileNumber,
      aadhaarNumber: String(f.aadhaarNumber),
      // aadhaarNumber: f.aadhaarNumber,
      aadhaarVerified: f.aadhaarVerified,
      dob: f.dob,
      nomineeState: f.nomineeState.name,
      nomineeDistrict: f.nomineeDistrict.name,
      nomineeLgdCode: f.nomineeLgdCode,
      trIdPrefix: f.trIdPrefix,
      trId: f.trId,
      arIdPrefix: f.arIdPrefix,
      arId: f.arId,
      tradeName: f.tradeName,
      nosCode: f.nosCode,
      sector: f.sector.sector,
      userCategory: f.userCategory,
      preferredLanguage: f.preferredLanguage,
      photoVideo: f.photoVideo,
      tradeCertificateDocs: f.tradeCertificateDocs,
      undertaking: f.undertaking,
      nominationType: this.capitalizeFirstLetter(this.typeOfSkilling),
      role: this.capitalizeFirstLetter(this.nominationOption)
    };
  }
  capitalizeFirstLetter(value: string | null): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  onSectorChange(selectedSector) {
    this.nominationForm.get('tradeName')?.reset();
    this.nominationForm.get('nosCode')?.reset();
    this.tradeNames = [];
    this.nosCodes = [];
    this.getQpListingByForm(selectedSector.sectorID);
  }
  getQpListingByForm(sectorId) {
    let queryParams: string = 'isPMV=true';
    if (sectorId) {
      queryParams += `&sectorID=${sectorId}`;
    }
    if (this.typeOfSkilling === 'basic') {
      queryParams += '&isBasic=true';
    } else if (this.typeOfSkilling === 'advance') {
      queryParams += '&isAdvance=true';
    }
    console.log('Final Query Params:', queryParams);
    this.sqaService.getQpListBySector(queryParams).subscribe(
      (res) => {
        console.log("ResponseForTradeName", res);
        if (res?.data?.docs?.length) {
          //  this.tradeNames = res.data.docs.map(item => item.jobRole);
          // this.nosCodes = res.data.docs
          //   .flatMap(item => item.compulsoryNos || [])
          //   .map(nos => nos.unitCode);

          this.tradeNames = res.data.docs.map(item => item.jobRole);
          this.tradeMessage = null;
          this.nosCodes = res.data.docs
            .flatMap(item => item.assmtCrt.compulsoryNos.assmtOutcm || [])
            .map(nos => nos.nosCode);

          console.log('Trade Names:', this.tradeNames);
          console.log('NOS Codes:', this.nosCodes);
        } else {
          this.tradeNames = [];
          this.nosCodes = [];
          this.tradeMessage = "Trade is not available/instantiated for this sector. Please select another sector/trade to continue!!";
        }
      },
      // (err) => {
      //  toastr.error("Unknown error");
      //  return;
      // }
    );
  }
  onDateChange(event: any, index: any, type: string) {
    console.log("date change", event.date, index);
    this.nominationForm.get("dob").patchValue(event.date.toISOString());
  }
  setDOB(event) {
    console.log(event);
    if (event) {
      this.nominationForm.get("dob").setValue(event.target.value);
    }
  }
  validate() {
    if (
      (this.nominationForm.get("aadhaarNumber").value
        .length !== 12 ||
        this.nominationForm.get("aadhaarNumber")
          .value === null) &&
      !this.nominationForm.get("participantName").value &&
      this.nominationForm.get("gender").value === undefined &&
      this.nominationForm.get("dob").value === ""
    ) {
      return;
    } else {
      const aadhaarData = {
        // AadharNumber: this.nominationForm
        //   .get("aadhaarNumber").value,
        AadharNumber: String(this.nominationForm.get("aadhaarNumber").value || '').padStart(12, '0'),
        Name: this.nominationForm.get("participantName").value,
        Gender:
          this.nominationForm.get("gender").value === "Male"
            ? "M"
            : this.nominationForm.get("gender").value === "Female"
              ? "F"
              : this.nominationForm.get("gender").value ===
                "Transgender"
                ? "T"
                : "",
        DateofBirth: this.formatDate(
          this.nominationForm.get("dob").value
        ),
      };
      this.aadharService.getDataEncryptorForNomination().subscribe((res) => {
        if (res.data) {
          const key = this.aadharService.decodeKey(res.data);
          const encryptedData = this.aadharService.encryptData(JSON.stringify(aadhaarData), key);
          this.aadharService
            .validateAadharNumberV2({ data: encryptedData })
            .subscribe((res) => {
              if (res) {
                console.log(res);
                if (res.RefKey) {
                  const encryptedAadhaarNumber =
                    this._getEncryptedData(
                      this.nominationForm
                        .get("aadhaarNumber").value
                    );
                  // this.nominationForm
                  //   .get("aadhaarNumber")
                  //   .patchValue(encryptedAadhaarNumber);
                  this.nominationForm
                    .get("aadhaarVerified")
                    .patchValue(true);
                  // this.nominationForm
                  //   .get("aadhaarIdentity")
                  //   .get("aadhaar")
                  //   .get("aadhaarRef")
                  //   .patchValue(res.RefKey);
                  // this.nominationForm
                  //   .get("aadhaarIdentity")
                  //   .get("value")
                  //   .patchValue(encryptedAadhaarNumber);
                  // this.nominationForm
                  //   .get("aadhaarIdentity")
                  //   .get("isValidated")
                  //   .patchValue(true);
                  this.nominationForm.get("aadhaarNumber").clearValidators();
                  this.nominationForm.get("aadhaarNumber").updateValueAndValidity();
                  this.nominationForm
                    .get("aadhaarNumber")
                    .disable();
                  this.nominationForm.get("participantName").clearValidators();
                  this.nominationForm.get("participantName").updateValueAndValidity();
                  this.nominationForm
                    .get("participantName")
                    .disable();
                  this.nominationForm.get("gender").clearValidators();
                  this.nominationForm.get("gender").updateValueAndValidity();
                  this.nominationForm.get("gender").disable();
                  this.nominationForm.get("dob").clearValidators();
                  this.nominationForm.get("dob").updateValueAndValidity();
                  this.nominationForm.get("dob").disable();
                  this._isAadhaarValidated = true;
                } else {
                  this._isAadhaarValidated = false;
                  this.nominationForm
                    .get("aadhaarVerified")
                    .patchValue(false);
                  toastr.error(`${res.Status}`);
                }
              }
            })
        }
      });
    }
  }
  formatDate(date) {
    const newDate = moment(date);
    return newDate.format("YYYY-DD-MM");
  }
  _getEncryptedData(aadno) {
    // let data = aadno;
    // data = "XXXXXXXX".concat(data.slice(-4));
    const dataStr = String(aadno);  // convert to string
    return "XXXXXXXX" + dataStr.slice(-4);
  }


  submitNominationForm() {
    console.log("NOMINATIONFORM", this.nominationForm.value);
    if (this.nominationForm.invalid) {
      this.nominationForm.markAllAsTouched();
      return;
    }
    swal({
      text: "Are you sure, you want to submit?",
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Submit",
    }).then((action: any) => {
      if (action.value) {
        const finalPayload = this.buildFinalPayload();

        this.userService.submitTrainerNomination(finalPayload).subscribe({
          next: (res) => {
            const uniqueId = res?.uniqueId ?? null;
            console.log('Unique ID:', uniqueId);
            swal({
              title: "Success",
              // text: "You have successfully nominated.",
              html: `You have successfully nominated.<br><span style="font-weight: bold;">Your Nomination ID is: ${uniqueId}</span>`,
              type: "success",
              confirmButtonText: "Close",
            }).then((action: any) => {
              if (action.value) {
                this.router.navigate(['/']);

              }
            });

          },
          error: (err) => {
            // this.nominationForm.reset();
            // this.nominationForm.patchValue(this.getNominationFormDefaults());
            // this.nominationForm.get('aadhaarNumber')?.setValidators([
            //   Validators.required,
            //   Validators.maxLength(12),
            //   Validators.pattern('^(0|[1-9][0-9]*)$')
            // ]);
            // this.nominationForm.get('aadhaarNumber')?.enable();
            // this.nominationForm.get('aadhaarNumber')?.updateValueAndValidity();

            // this.nominationForm.get('participantName')?.setValidators(Validators.required);
            // this.nominationForm.get('participantName')?.enable();
            // this.nominationForm.get('participantName')?.updateValueAndValidity();

            // this.nominationForm.get('gender')?.setValidators(Validators.required);
            // this.nominationForm.get('gender')?.enable();
            // this.nominationForm.get('gender')?.updateValueAndValidity();

            // this.nominationForm.get('dob')?.setValidators(Validators.required);
            // this.nominationForm.get('dob')?.enable();
            // this.nominationForm.get('dob')?.updateValueAndValidity();

          }
        });

      }
    });
  }
}
export function startsWithValidator(prefixes: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const isValid = prefixes.some(prefix => value.startsWith(prefix));
    if (!isValid) {
      return { startsWith: { requiredPrefixes: prefixes } };
    }
    return null;
  };
}

// export function startsWithValidator(prefix: string): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const value = control.value;
//     if (value && !value.startsWith(prefix)) {
//       return { startsWith: { requiredPrefix: prefix } };
//     }
//     return null;
//   };
// }